import * as React from 'react';
import { FormProvider, Resolver, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { ArrowBack } from '@mui/icons-material';
import { Button } from 'components';
import { useLocalize } from 'store/contexts/LocalizationContext/LocalizationContext.provider';
import { useAppDispatch } from 'store/store';
import { pushNotification } from 'store/notifications/notifications.slices';
import { NOTIFICATION_TYPES } from 'store/notifications/notifications.types';
import { getOrderFormSchema } from '../OrderForm/OrderForm.schema';
import { OrderForm } from '../OrderForm/OrderForm';
import {
  formValuesToOrderItem,
  orderItemToFormValues,
} from '../OrderForm/OrderForm.utils';
import { TOrderFormValues } from '../OrderForm/OrderForm.types';
import { TOrderEdit } from './OrderEdit.types';
import '../OrderDetail/OrderDetail.styled.scss';
import '../../../../AdminPanel.styles.scss';

export const OrderEdit: TOrderEdit = ({ order, onBack }) => {
  const localize = useLocalize();
  const dispatch = useAppDispatch();

  const orderFormSchema = React.useMemo(
    () => getOrderFormSchema(localize),
    [localize]
  );

  const form = useForm<TOrderFormValues>({
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    defaultValues: orderItemToFormValues(order),
    resolver: yupResolver(orderFormSchema) as Resolver<TOrderFormValues>,
  });

  React.useEffect(() => {
    form.reset(orderItemToFormValues(order));
  }, [order, form]);

  const handleSubmit = (data: TOrderFormValues) => {
    // eslint-disable-next-line no-console
    console.log('order edit', formValuesToOrderItem(data));
    dispatch(
      pushNotification({
        message: localize('admin.orders.form.saved') as string,
        type: NOTIFICATION_TYPES.SUCCESS,
      })
    );
    onBack();
  };

  return (
    <div className="admin-orders-detail">
      <div className="admin-orders-detail__toolbar">
        <Button
          type="button"
          variant="outlined"
          startIcon={<ArrowBack />}
          onClick={onBack}
        >
          {localize('admin.orders.back.detail')}
        </Button>
        <div className="admin-orders-detail__toolbar-center">
          <h2 className="h5 admin-orders-detail__title">
            {localize('admin.orders.form.title.edit')}
          </h2>
        </div>
        <span className="admin-orders-detail__toolbar-spacer" aria-hidden />
      </div>

      <FormProvider {...form}>
        <OrderForm mode="edit" onSubmit={handleSubmit} />
      </FormProvider>
    </div>
  );
};
